import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import Axis from "../../../../images/axis.svg";
import Curves from "../../../../images/curves.svg";
import SwLine from "../../../../images/newSwLine.svg";
import TariffLine from "../../../../images/New-tariff.svg";
import horGreen from "../../../../images/horGreen1.svg";
import horRed from "../../../../images/horRed.svg";
import vertRed from "../../../../images/vertRed.svg";
import vertRedHalf from "../../../../images/vertRedHalf.svg";
import vertRedHalfNew from "../../../../images/Vert-red-quarter.svg";

// import vertwhiteHalf from "../../../../images/Qo-white.png";
import vertwhiteHalf from "../../../../images/Vert-white-quarter.svg";

import QsWhite from "../../../../images/QsWhite.svg";
import QoWhite from "../../../../images/QoWhite.svg";

import QdWhite from "../../../../images/QdWhite.svg";
import HorBlue from "../../../../images/Hor-white3.png";
import Powhite from "../../../../images/Powhite.svg";

import QdHalfBlue from "../../../../images/QdBlue.svg";

import HalfBlue from "../../../../images/Qd2BlueHalf.svg";
import HalfBlueNew from "../../../../images/Vert-blue-quarter.svg";
import VertGreenHalf from "../../../../images/Vert-green-quarter.svg";
import { mergeClasses } from "@material-ui/styles";

const SecondGraphTariff = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnsweredPartialy,
    setPhase2Answers,
    setAnswers,
    answers,
    phase2Answers,
    selectedOption,
  } = props;

  const [onSelect, setOnSelect] = useState(-1);
  const [selected, setSelected] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);

  const [horBlueLine, setHorBlueLine] = useState(false);
  const [vertBlueLine, setVertBlueLine] = useState(false);

  const [vert1HalfBlue, setVert1HalfBlue] = useState(false);
  const [vert2HalfBlue, setVert2HalfBlue] = useState(false);
  const [vert3HalfBlue, setVert3HalfBlue] = useState(false);

  const [horGreenLine, setHorGreenLine] = useState(false);
  const [vertGreenHalfLine, setVertGreenHalfLine] = useState(false);

  const [horRedLine, setHorRedLine] = useState(false);
  const [vertRedLine, setVertRedLine] = useState(false);

  const [vertRedHalfLine, setVertRedHalfLine] = useState(false);
  const [vertRedHalf2Line, setVertRedHalf2Line] = useState(false);
  const [vertRedHalf3Line, setVertRedHalf3Line] = useState(false);
  const [vertRedHalf4Line, setVertRedHalf4Line] = useState(false);

  const [Qd2WhiteLine, setQd2WhiteRedLine] = useState(false);

  // line 3
  const [line3White, setLine3White] = useState(true);
  const [line3Blue, setLine3Blue] = useState(false);
  const [line3Green, setLine3Green] = useState(false);
  const [line3Red, setLine3Red] = useState(false);

  // line 3
  const [line4White, setLine4White] = useState(true);
  const [line4Blue, setLine4Blue] = useState(false);
  const [line4Green, setLine4Green] = useState(false);
  const [line4Red, setLine4Red] = useState(false);

  // line 5
  const [line5White, setLine5White] = useState(true);
  const [line5Blue, setLine5Blue] = useState(false);
  const [line5Green, setLine5Green] = useState(false);
  const [line5Red, setLine5Red] = useState(false);

  const _onMouseMove = (e) => {
    // console.log(e.screenX - e.screenY);
    // this.setState({ x: e.screenX, y: e.screenY });
  };

  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#fff";
    }
  };

  console.log("onSelect", onSelect);

  const markSelected = (triangle) => {
    if (!submitted) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }

      if (!submitted && selected.includes(1) && selected.includes(2)) {
        setHorBlueLine(true);
      } else {
        setHorBlueLine(false);
      }

      if (!submitted && selected.includes(3) && selected.includes(4)) {
        setVertBlueLine(true);
      } else {
        setVertBlueLine(false);
      }

      if (!submitted && selected.includes(6) && selected.includes(7)) {
        setLine3Blue(true);
      } else {
        setLine3Blue(false);
      }

      if (!submitted && selected.includes(7) && selected.includes(8)) {
        setLine4Blue(true);
      } else {
        setLine4Blue(false);
      }

      if (!submitted && selected.includes(8) && selected.includes(9)) {
        setLine5Blue(true);
      } else {
        setLine5Blue(false);
      }

      if (!submitted && selected.includes(11) && selected.includes(12)) {
        setVert2HalfBlue(true);
      } else {
        setVert2HalfBlue(false);
      }

      if (!submitted && selected.includes(12) && selected.includes(13)) {
        setVert1HalfBlue(true);
      } else {
        setVert1HalfBlue(false);
      }

      if (!submitted && selected.includes(13) && selected.includes(14)) {
        setVert3HalfBlue(true);
      } else {
        setVert3HalfBlue(false);
        console.log("selected", triangle);
      }
    }
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  const notQuiteFun = () => {
    let is_partial = "F";
    selected.map((ans) => {
      if (is_partial || is_partial === "F") {
        is_partial = true;
      }
      if (!questionAnswer.answer.includes(ans)) {
        is_partial = false;
      }
    });
    return is_partial === true ? true : false;
  };

  useEffect(() => {
    if (questionAnswer.options && submitted) {
      let tempAnswer = answers;
      const intToString = { 0: "A", 1: "B" };
      if (questionAnswer.answer.includes(intToString[selectedOption])) {
        setAnsweredCorrectly(true);
        tempAnswer.push(true);
      } else {
        setAnsweredCorrectly(false);
        tempAnswer.push(false);
      }
      setAnswers(tempAnswer);
    } else {
      let is_true = true;
      questionAnswer.answer.map((ans) => {
        if (!selected.includes(ans)) {
          is_true = false;
        }
      });
      const answer =
        is_true && selected.length === questionAnswer.answer.length;
      if (submitted) {
        let tempAnswer = answers;
        if (answer) {
          tempAnswer.push(true);
          setAnswers(tempAnswer);
          if (
            questionAnswer.answer.includes(1) &&
            questionAnswer.answer.includes(2)
          ) {
            setHorBlueLine(false);
            setHorGreenLine(true);
          }
          if (
            questionAnswer.answer.includes(3) &&
            questionAnswer.answer.includes(4)
          ) {
            setVertBlueLine(false);
            setVertGreenHalfLine(true);
          }
          if (
            questionAnswer.answer.includes(6) &&
            questionAnswer.answer.includes(7)
          ) {
            setLine3Blue(false);
            setLine3Green(true);
          }

          if (
            questionAnswer.answer.includes(7) &&
            questionAnswer.answer.includes(8)
          ) {
            setLine4Blue(false);
            setLine4Green(true);
          }
          if (
            questionAnswer.answer.includes(8) &&
            questionAnswer.answer.includes(9)
          ) {
            setLine5Blue(false);
            setLine5Green(true);
          }
          setAnsweredCorrectly(true);
        } else {
          tempAnswer.push(false);
          setAnswers(tempAnswer);
          let is_partial = false;
          if (selected.length < questionAnswer.answer.length) {
            is_partial = notQuiteFun();
            // selected.map((ans) => {
            //   is_partial = true;
            //   if (!questionAnswer.answer.includes(ans)) {
            //     is_partial = false;
            //   }
            // });
          }
          if (is_partial) {
            setAnsweredPartialy(true);
          } else {
            setAnsweredPartialy(false);
            setAnsweredCorrectly(false);
          }
          if (
            questionAnswer.answer.includes(1) &&
            questionAnswer.answer.includes(2)
          ) {
            setHorBlueLine(false);
            setHorGreenLine(true);
          }
          if (
            questionAnswer.answer.includes(3) &&
            questionAnswer.answer.includes(4)
          ) {
            setVertRedHalf4Line(false);
            setVertBlueLine(false);
            setVertGreenHalfLine(true);
          }
          if (selected.includes(1) && selected.includes(2)) {
            if (
              questionAnswer.answer.includes(1) &&
              questionAnswer.answer.includes(2)
            ) {
              setHorBlueLine(false);
              setHorGreenLine(true);
            } else {
              setHorBlueLine(false);
              setHorRedLine(true);
            }
          }
          if (selected.includes(11) && selected.includes(12)) {
            // red horizontal line
            setVertRedHalfLine(true);
          }
          if (selected.includes(12) && selected.includes(13)) {
            // red horizontal7.5line
            setVertRedHalf2Line(true);
          }
          if (selected.includes(3) && selected.includes(4)) {
            if (
              questionAnswer.answer.includes(3) &&
              questionAnswer.answer.includes(4)
            ) {
              setVertRedHalf4Line(false);
              setVertBlueLine(false);
              setVertGreenHalfLine(true);
            } else {
              setVertBlueLine(false);
              setVertRedHalf4Line(true);
            }
          }

          if (
            questionAnswer.answer.includes(6) &&
            questionAnswer.answer.includes(7)
          ) {
            setLine3Blue(false);
            setLine3Green(true);
          }

          if (selected.includes(6) && selected.includes(7)) {
            if (
              questionAnswer.answer.includes(6) &&
              questionAnswer.answer.includes(7)
            ) {
              setLine3Red(false);
              setLine3Blue(false);
              setLine3Green(true);
            } else {
              setLine3Red(true);
              setLine3Blue(false);
            }
          }

          if (
            questionAnswer.answer.includes(7) &&
            questionAnswer.answer.includes(8)
          ) {
            setLine4Red(false);
            setLine4Blue(false);
            setLine4Green(true);
          }

          if (selected.includes(7) && selected.includes(8)) {
            if (
              questionAnswer.answer.includes(7) &&
              questionAnswer.answer.includes(8)
            ) {
              setLine4Red(false);
              setLine4Blue(false);
              setLine4Green(true);
            } else {
              setLine4Red(true);
              setLine4Blue(false);
            }
          }

          if (
            questionAnswer.answer.includes(8) &&
            questionAnswer.answer.includes(9)
          ) {
            setLine5Red(false);
            setLine5Blue(false);
            setLine5Green(true);
          }
          if (selected.includes(8) && selected.includes(9)) {
            if (
              questionAnswer.answer.includes(8) &&
              questionAnswer.answer.includes(9)
            ) {
              setLine5Red(false);
              setLine5Blue(false);
              setLine5Green(true);
            } else {
              setLine5Red(true);
              setLine5Blue(false);
            }
          }

          if (selected.includes(13) && selected.includes(14)) {
            // red horizontal line
            setVert3HalfBlue(false);
            setVertRedHalf3Line(true);
          }
        }
      }
    }
  }, [submitted]);

  const [test, setTest] = useState(false);

  const permentLine = () => {
    return <img src={TariffLine} className={classes.tariffLine} alt="" />;
  };

  // setTimeout(() => {
  //   setTest(true);
  // }, 1100);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    return (
      <div className={classes.internationalContainerMajor}>
        {permentLine()}

        <div
          className={
            questionAnswer.options
              ? classes.disabledInternationalContainerChild
              : classes.internationalContainerChild
          }
          onMouseMove={_onMouseMove}
        >
          <img src={Axis} style={{ height: "100%", zIndex: 2 }} alt="" />
          <img
            src={Curves}
            style={{ height: "100%", position: "absolute", zIndex: 2 }}
            alt=""
          />
          <img
            src={SwLine}
            style={{
              height: "11.7%",
              position: "absolute",
              zIndex: 2,
              marginLeft: "19%",
              paddingTop: "55%",
            }}
            alt=""
          />
          {/* ************** Line 1 ********************* */}

          {/* line-1-white */}
          <img className={classes.poWhite} src={Powhite} alt="" />
          {/* line-1-blue */}
          <img
            className={classes.horizontalBlue}
            src={HorBlue}
            style={{
              zIndex: horBlueLine ? 1 : -1,
            }}
            alt=""
          />
          {/* line-1-green */}
          <img
            className={classes.horizontalGreenLine}
            src={horGreen}
            style={{
              zIndex: horGreenLine ? 1 : -1,
            }}
            alt=""
          />
          {/* line-1-red */}
          <img
            className={classes.horizontalRedLine}
            src={horRed}
            style={{
              zIndex: horRedLine ? 1 : -1,
            }}
            alt=""
          />

          {/* ************** Line 2 ********************* */}
          {/* line-2-white */}
          <img className={classes.vertWhiteHalf} src={vertwhiteHalf} alt="" />
          {/* line-2-blue */}
          <img
            className={classes.vertWhiteHalf}
            // className={classes.verticleBlueHalf}
            src={HalfBlueNew}
            style={{
              zIndex: vertBlueLine ? 1 : -1,
            }}
            alt=""
          />

          {/* line-2-green */}
          <img
            className={classes.vertWhiteHalf}
            // className={classes.verticleGreenHalf}
            src={VertGreenHalf}
            style={{
              zIndex: vertGreenHalfLine ? 1 : -1,
            }}
            alt=""
          />
          {/* line-2-red */}
          <img
            src={vertRedHalfNew}
            className={classes.vertWhiteHalf}
            // className={classes.vertRedHalf}
            style={{
              zIndex: vertRedHalf4Line ? 1 : -1,
            }}
            alt=""
          />

          {/* <img
            src={HalfBlue}
            style={{
              height: "18%",
              top: 261,
              position: "absolute",
              left: 286,
              zIndex: vert1HalfBlue ? 1 : -1,
            }}
            alt=""
          /> */}

          {/* ************** Line 3 ********************* */}
          {/* line-3-white */}
          <img className={classes.line3} src={vertwhiteHalf} alt="" />
          {/* line-3-blue */}
          <img
            className={classes.line3}
            src={HalfBlueNew}
            style={{
              zIndex: line3Blue ? 1 : -1,
            }}
            alt=""
          />

          {/* line-3-green */}
          <img
            className={classes.line3}
            src={VertGreenHalf}
            style={{
              zIndex: line3Green ? 1 : -1,
            }}
            alt=""
          />
          {/* line-3-red */}
          <img
            src={vertRedHalfNew}
            className={classes.line3}
            style={{
              zIndex: line3Red ? 1 : -1,
            }}
            alt=""
          />

          {/* ************** Line 4 ********************* */}

          {/* line-4-white */}
          <img className={classes.vertWhiteHalf1} src={vertwhiteHalf} alt="" />
          {/* line-4-blue */}
          <img
            className={classes.vertWhiteHalf1}
            src={HalfBlueNew}
            style={{
              zIndex: line4Blue ? 1 : -1,
            }}
            alt=""
          />

          {/* line-4-green */}
          <img
            className={classes.vertWhiteHalf1}
            src={VertGreenHalf}
            style={{
              zIndex: line4Green ? 1 : -1,
            }}
            alt=""
          />
          {/* line-4-red */}
          <img
            src={vertRedHalfNew}
            className={classes.vertWhiteHalf1}
            style={{
              zIndex: line4Red ? 1 : -1,
            }}
            alt=""
          />

          {/* ************** Line 5 ********************* */}

          {/* line-5-white */}
          <img className={classes.line5} src={vertwhiteHalf} alt="" />
          {/* line-5-blue */}
          <img
            className={classes.line5}
            src={HalfBlueNew}
            style={{
              zIndex: line5Blue ? 1 : -1,
            }}
            alt=""
          />

          {/* line-5-green */}
          <img
            className={classes.line5}
            src={VertGreenHalf}
            style={{
              zIndex: line5Green ? 1 : -1,
            }}
            alt=""
          />
          {/* line-5-red */}
          <img
            src={vertRedHalfNew}
            className={classes.line5}
            style={{
              zIndex: line5Red ? 1 : -1,
            }}
            alt=""
          />

          {/* ************** Line 6 ********************* */}
          {/* line-6-white */}
          <img className={classes.qsWhite} src={QsWhite} alt="" />

          {/* line-6-blue */}
          <img
            className={classes.verticle2HalfBlue}
            src={HalfBlue}
            style={{
              zIndex: vert2HalfBlue ? 2 : -1,
            }}
            alt=""
          />
          {/* line-6-red */}
          <img
            className={classes.verticle1HalfRed}
            src={vertRedHalf}
            style={{
              zIndex: vertRedHalfLine ? 2 : -1,
            }}
            alt=""
          />

          {/* ************** Line 7 ********************* */}

          {/* line-7-white */}
          <img className={classes.qoWhite} src={QoWhite} alt="" />

          {/* line-7-blue */}
          <img
            className={classes.verticle1HalfBlue}
            src={HalfBlue}
            style={{
              zIndex: vert1HalfBlue ? 1 : -1,
            }}
            alt=""
          />
          {/* line-7-red */}
          <img
            className={classes.verticle2HalfRed}
            src={vertRedHalf}
            style={{
              zIndex: vertRedHalf2Line ? 1 : -1,
            }}
            alt=""
          />

          {/* ************** Line 8 ********************* */}

          {/* line-8-white */}
          <img
            className={classes.qdWhite}
            src={QdWhite}
            style={{
              zIndex: vert3HalfBlue ? -1 : 1,
            }}
            alt=""
          />
          {/* line-8-blue */}

          <img
            className={classes.verticle3HalfBlue}
            src={QdHalfBlue}
            style={{
              zIndex: vert3HalfBlue ? 1 : -1,
            }}
            alt=""
          />
          {/* line-8-red */}
          <img
            className={classes.verticle3HalfRed}
            src={vertRedHalf}
            style={{
              zIndex: vertRedHalf3Line ? 1 : -1,
            }}
            alt=""
          />

          {/* line-2-5-6-red */}
          {/* <img
            src={vertRed}
            style={{
              height: "34%",
              top: 195,
              right: 98,
              position: "absolute",
              zIndex: vertRedLine ? 1 : -1,
            }}
            alt=""
          /> */}

          {/* triangle # 1 */}
          <div className={classes.shape2Major}>
            <div
              className={classes.shape2}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(1)
                    ? "green"
                    : selected.includes(1)
                    ? "red"
                    : "#fff"
                  : selected.includes(1)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(1)
                  ? console.log("hhhh")
                  : !checkSelection(1) && resetBackground
              }
              onMouseOver={
                selected.includes(1)
                  ? console.log("1")
                  : !checkSelection(1) && changeBackground
              }
              onClick={() => markSelected(1)}
            />

            <div
              style={{
                width: 186.5,
                height: 62,
                overflow: "hidden",
                top: 147,
                position: "absolute",
                zIndex: 3,

                // zIndex: 1,
              }}
            >
              <div
                style={{
                  float: "left",
                  height: 62,
                  clipPath: "polygon(0 0, 100% 0, 54% 100%, 0 100%)",
                  shapeOutside: "polygon(0 0, 100% 0, 54% 100%, 0 100%)",
                  width: 180,
                  backgroundColor: submitted
                    ? correctAnswer.includes(3)
                      ? "green"
                      : selected.includes(3)
                      ? "red"
                      : "#fff"
                    : selected.includes(3)
                    ? "#00b1d9"
                    : "#fff",
                }}
                onMouseOut={
                  selected.includes(3)
                    ? console.log("hhhh")
                    : !checkSelection(3) && resetBackground
                }
                onMouseOver={
                  selected.includes(3)
                    ? console.log("3")
                    : !checkSelection(3) && changeBackground
                }
                onClick={() => markSelected(3)}
              ></div>
              <div
                style={{
                  float: "left",
                  height: 59,
                  clipPath: "polygon(100% 0, 100% 100%, 0 100%)",
                  shapeOutside: "polygon(100% 0, 100% 100%, 0 100%)",
                  width: 79,
                  backgroundColor: submitted
                    ? correctAnswer.includes(4)
                      ? "green"
                      : selected.includes(4)
                      ? "red"
                      : "#fff"
                    : selected.includes(4)
                    ? "#00b1d9"
                    : "#fff",
                  position: "absolute",
                  left: 108,
                  top: 3.5,
                }}
                onMouseOut={
                  selected.includes(4)
                    ? console.log("hhhh")
                    : !checkSelection(4) && resetBackground
                }
                onMouseOver={
                  selected.includes(4)
                    ? console.log("4")
                    : !checkSelection(4) && changeBackground
                }
                onClick={() => markSelected(4)}
              ></div>
            </div>
          </div>
          {/* triangle # 2 */}
          <div className={classes.shape5Major}>
            <div
              className={classes.shape5}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(2)
                    ? "green"
                    : selected.includes(2)
                    ? "red"
                    : "#fff"
                  : selected.includes(2)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(2)
                  ? console.log("hhhh")
                  : !checkSelection(2) && resetBackground
              }
              onMouseOver={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && changeBackground
              }
              onClick={() => markSelected(2)}
            ></div>
          </div>

          {/* triangle # 3 */}
          <div className={classes.shape6Major}>
            <div
              className={classes.shape6}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(3)
                    ? "green"
                    : selected.includes(3)
                    ? "red"
                    : "#fff"
                  : selected.includes(3)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(3)
                  ? console.log("hhhh")
                  : !checkSelection(3) && resetBackground
              }
              onMouseOver={
                selected.includes(3)
                  ? console.log("3")
                  : !checkSelection(3) && changeBackground
              }
              onClick={() => markSelected(3)}
            ></div>
          </div>

          {/* triangle # 4 */}
          <div className={classes.shape7Major}>
            <div
              className={classes.shape7}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(4)
                    ? "green"
                    : selected.includes(4)
                    ? "red"
                    : "#fff"
                  : selected.includes(4)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(4)
                  ? console.log("hhhh")
                  : !checkSelection(4) && resetBackground
              }
              onMouseOver={
                selected.includes(4)
                  ? console.log("4")
                  : !checkSelection(4) && changeBackground
              }
              onClick={() => markSelected(4)}
            ></div>
          </div>

          {/* triangle # 5 */}
          <div className={classes.shape5LowerMajor}>
            <div
              className={classes.shape5Lower}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(5)
                    ? "green"
                    : selected.includes(5)
                    ? "red"
                    : "#fff"
                  : selected.includes(5)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(5)
                  ? console.log("hhhh")
                  : !checkSelection(5) && resetBackground
              }
              onMouseOver={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && changeBackground
              }
              onClick={() => markSelected(5)}
            ></div>
          </div>

          {/* triangle # 6 */}
          <div className={classes.shape6LowerMajor}>
            <div
              className={classes.shape6Lower}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(6)
                    ? "green"
                    : selected.includes(6)
                    ? "red"
                    : "#fff"
                  : selected.includes(6)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(6)
                  ? console.log("hhhh")
                  : !checkSelection(6) && resetBackground
              }
              onMouseOver={
                selected.includes(6)
                  ? console.log("6")
                  : !checkSelection(6) && changeBackground
              }
              onClick={() => markSelected(6)}
            ></div>
          </div>
          {/* triangle # 7 */}
          <div className={classes.shape6LowerMajor2}>
            <div
              className={classes.shape6Lower2}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(7)
                    ? "green"
                    : selected.includes(7)
                    ? "red"
                    : "#fff"
                  : selected.includes(7)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(7)
                  ? console.log("hhhh")
                  : !checkSelection(7) && resetBackground
              }
              onMouseOver={
                selected.includes(7)
                  ? console.log("7")
                  : !checkSelection(7) && changeBackground
              }
              onClick={() => markSelected(7)}
            ></div>
          </div>

          {/* triangle # 8 */}
          <div className={classes.shape7LowerMajor}>
            <div
              className={classes.shape7Lower}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(8)
                    ? "green"
                    : selected.includes(8)
                    ? "red"
                    : "#fff"
                  : selected.includes(8)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(8)
                  ? console.log("hhhh")
                  : !checkSelection(8) && resetBackground
              }
              onMouseOver={
                selected.includes(8)
                  ? console.log("8")
                  : !checkSelection(8) && changeBackground
              }
              onClick={() => markSelected(8)}
            ></div>
          </div>
          {/* triangle # 9 */}
          <div className={classes.shape7LowerMajor2}>
            <div
              className={classes.shape7Lower2}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(9)
                    ? "green"
                    : selected.includes(9)
                    ? "red"
                    : "#fff"
                  : selected.includes(9)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(9)
                  ? console.log("hhhh")
                  : !checkSelection(9) && resetBackground
              }
              onMouseOver={
                selected.includes(9)
                  ? console.log("9")
                  : !checkSelection(9) && changeBackground
              }
              onClick={() => markSelected(9)}
            ></div>
          </div>
          {/* triangle # 10 */}
          <div className={classes.shape8Major}>
            <div
              className={classes.shape8}
              style={{
                float: "left",
                clipPath: "polygon(100% 0, 0 0, 0 100%)",
                shapeOutside: "polygon(100% 0, 0 0, 0 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(10)
                    ? "green"
                    : selected.includes(10)
                    ? "red"
                    : "#fff"
                  : selected.includes(10)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(10)
                  ? console.log("hhhh")
                  : !checkSelection(10) && resetBackground
              }
              onMouseOver={
                selected.includes(10)
                  ? console.log("10")
                  : !checkSelection(10) && changeBackground
              }
              onClick={() => markSelected(10)}
            ></div>
          </div>

          {/* triangle # 11 */}
          <div className={classes.shape9Major}>
            <div
              className={classes.shape9}
              style={{
                float: "left",
                clipPath: "polygon(68% 0, 100% 0, 100% 100%, 0% 100%)",
                shapeOutside: "polygon(68% 0, 100% 0, 100% 100%, 0% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(11)
                    ? "green"
                    : selected.includes(11)
                    ? "red"
                    : "#fff"
                  : selected.includes(11)
                  ? "#00b1d9"
                  : "#fff",
                position: "absolute",
              }}
              onMouseOut={
                selected.includes(11)
                  ? console.log("hhhh")
                  : !checkSelection(11) && resetBackground
              }
              onMouseOver={
                selected.includes(11)
                  ? console.log("11")
                  : !checkSelection(11) && changeBackground
              }
              onClick={() => markSelected(11)}
            ></div>
          </div>

          {/* triangle # 12 */}
          <div className={classes.shape10Major}>
            <div
              className={classes.shape10}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                backgroundColor: submitted
                  ? correctAnswer.includes(12)
                    ? "green"
                    : selected.includes(12)
                    ? "red"
                    : "#fff"
                  : selected.includes(12)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(12)
                  ? console.log("hhhh")
                  : !checkSelection(12) && resetBackground
              }
              onMouseOver={
                selected.includes(12)
                  ? console.log("12")
                  : !checkSelection(12) && changeBackground
              }
              onClick={() => markSelected(12)}
            ></div>
          </div>

          {/* triangle # 13 */}
          <div className={classes.shape11Major}>
            <div
              className={classes.shape11}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                backgroundColor: submitted
                  ? correctAnswer.includes(13)
                    ? "green"
                    : selected.includes(13)
                    ? "red"
                    : "#fff"
                  : selected.includes(13)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(13)
                  ? console.log("hhhh")
                  : !checkSelection(13) && resetBackground
              }
              onMouseOver={
                selected.includes(13)
                  ? console.log("13")
                  : !checkSelection(13) && changeBackground
              }
              onClick={() => markSelected(13)}
            ></div>
          </div>

          {/* triangle # 14 */}
          <div className={classes.shape12Major}>
            <div
              className={classes.shape12}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 35% 0, 100% 100%, 0% 100%)",
                shapeOutside: "polygon(0 0, 35% 0, 100% 100%, 0% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(14)
                    ? "green"
                    : selected.includes(14)
                    ? "red"
                    : "#fff"
                  : selected.includes(14)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(14)
                  ? console.log("hhhh")
                  : !checkSelection(14) && resetBackground
              }
              onMouseOver={
                selected.includes(14)
                  ? console.log("14")
                  : !checkSelection(14) && changeBackground
              }
              onClick={() => markSelected(14)}
            ></div>
          </div>

          {/* triangle # 15 */}
          <div className={classes.shape13Major}>
            <div
              className={classes.shape13}
              style={{
                float: "left",
                clipPath: "polygon(100% 0, 0 0, 100% 100%)",
                shapeOutside: "polygon(100% 0, 0 0, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(15)
                    ? "green"
                    : selected.includes(15)
                    ? "red"
                    : "#fff"
                  : selected.includes(15)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(15)
                  ? console.log("hhhh")
                  : !checkSelection(15) && resetBackground
              }
              onMouseOver={
                selected.includes(15)
                  ? console.log("15")
                  : !checkSelection(15) && changeBackground
              }
              onClick={() => markSelected(15)}
            ></div>
          </div>
          {/* triangle # 16 */}

          <div className={classes.shape14LowerMajor}>
            <div
              className={classes.shape14Lower}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(16)
                    ? "green"
                    : selected.includes(16)
                    ? "red"
                    : "#fff"
                  : selected.includes(16)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(16)
                  ? console.log("hhhh")
                  : !checkSelection(16) && resetBackground
              }
              onMouseOver={
                selected.includes(16)
                  ? console.log("16")
                  : !checkSelection(16) && changeBackground
              }
              onClick={() => markSelected(16)}
            ></div>
          </div>

          {/* triangle # 17 */}
          <div className={classes.shape14Major}>
            <div
              className={classes.shape14}
              style={{
                float: "left",
                backgroundColor: submitted
                  ? correctAnswer.includes(17)
                    ? "green"
                    : selected.includes(17)
                    ? "red"
                    : "#fff"
                  : selected.includes(17)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(17)
                  ? console.log("hhhh")
                  : !checkSelection(17) && resetBackground
              }
              onMouseOver={
                selected.includes(17)
                  ? console.log("17")
                  : !checkSelection(17) && changeBackground
              }
              onClick={() => markSelected(17)}
            ></div>
          </div>

          {/* triangle # 18 */}
          <div
            className={classes.shape1Major}
            style={{
              clipPath: "polygon(0 7px, 49.1% 100%, 100% 4px)",
              shapeOutside: "polygon(0 7px, 49.1% 100%, 100% 4px)",
            }}
          >
            <div
              className={classes.shape1}
              style={{
                float: "left",
                clipPath: "polygon(0 7px, 49.1% 100%, 100% 4px)",
                shapeOutside: "polygon(0 7px, 49.1% 100%, 100% 4px)",
                backgroundColor: submitted
                  ? correctAnswer.includes(18)
                    ? "green"
                    : selected.includes(18)
                    ? "red"
                    : "#fff"
                  : selected.includes(18)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(18)
                  ? console.log("hhhh")
                  : !checkSelection(18) && resetBackground
              }
              onMouseOver={
                selected.includes(18)
                  ? console.log("18")
                  : !checkSelection(18) && changeBackground
              }
              onClick={() => markSelected(18)}
            />
          </div>
        </div>
      </div>
    );
  };

  return <Grid style={{ width: 565 }}>{demandCurveResponsive()}</Grid>;
};

export default withStyles(styles)(SecondGraphTariff);
